export default function EventsHero() {
	const heroTicket = document.querySelector('.buyHeroTicket');
	const otherDatesCheck = document.querySelector('.otherDates');
	if (heroTicket) {
		let dataId = heroTicket.dataset.id;
		if (dataId !== null || dataId !== undefined) {
			$.get(
				'/actions/my-module/default/available-tickets-check',
				{ arrayOfIds: dataId },
				function (res) {
					if (res.length > 2) {
						let jsonData = JSON.parse(res);
						let count = jsonData[0].AvailableCount;

						if (count < 1) {
							heroTicket.classList.toggle('buyHeroTicket--disabled');
						}
						if (!otherDatesCheck && count < 1) {
							let heroBadges = document.querySelector('.heroBadges');
							if (heroBadges) {
								let badge = document.createElement('div');
								badge.classList.add('heroBadges__badge');
								badge.classList.add('heroBadges__badge--red');
								let pText = document.createElement('p');
								pText.textContent = 'Sold out';
								badge.appendChild(pText);
								heroBadges.appendChild(badge);
							} else {
								let heroInnerDiv = document.querySelector(
									'.hero_contentInside'
								);
								let heroBadgeDiv = document.createElement('div');
								heroBadgeDiv.classList.add('heroBadges');
								let badge = document.createElement('div');
								badge.classList.add('heroBadges__badge');
								badge.classList.add('heroBadges__badge--red');
								let pText = document.createElement('p');
								pText.textContent = 'Sold out';
								badge.appendChild(pText);
								heroBadgeDiv.appendChild(badge);
								heroInnerDiv.insertBefore(
									heroBadgeDiv,
									heroInnerDiv.firstChild
								);
							}
						}
					} else {
						heroTicket.classList.add('buyHeroTicket--disabled');
					}
				}
			);
		}
	}

	// introBlock right ticket check
	let ticketButtons = document.querySelectorAll('.ticketCheck');
	ticketButtons.forEach((item) => {
		console.log('here');
		let id = item.dataset.tess;
		if (!id) {
			return;
		} else {
			$.get(
				'/actions/my-module/default/available-tickets-check',
				{ arrayOfIds: id },
				function (res) {
					if (res.length > 2) {
						let jsonData = JSON.parse(res);
						let count = jsonData[0].AvailableCount;
						if (count < 1) {
							if (item.classList.contains('ticketCheck--disabled')) {
								return;
							}
							item.classList.add('ticketCheck--disabled');
						}
					} else {
						item.classList.add('ticketCheck--disabled');
					}
				}
			);
		}
	});

	// add to calendar toggling
	let addToCal = document.querySelectorAll('.addToCal');
	if (addToCal) {
		function toggleLinks(event) {
			let dataId = event.target.dataset.id;
			let cal = $('.addToCal__cont[data-id="' + dataId + '"]');
			cal.toggleClass('addToCal__cont--open');
		}

		addToCal.forEach(function (element) {
			element.addEventListener('click', toggleLinks);
		});
	}

	const addToCalendars = document.querySelectorAll('.addToCal__cont');
	function closeAddToCals() {
		if (addToCalendars) {
			addToCalendars.forEach(function (el) {
				if (el.classList.contains('addToCal__cont--open')) {
					el.classList.remove('addToCal__cont--open');
				}
			});
		}
	}

	// modal for other dates
	const otherDates = document.querySelector('.otherDates');

	const evModal = document.querySelector('.evModal');
	if (otherDates) {
		function openModal() {
			console.log('here');
			evModal.classList.add('evModal--open');
			window.scrollTo({
				top: 0,
				behavior: 'smooth',
			});
		}
		function checkTickets() {
			const dates = document.querySelectorAll('.evModal__item');
			dates.forEach((item, index) => {
				if (item.dataset.id !== undefined) {
					let dataId = item.dataset.id;
					$.get(
						'/actions/my-module/default/available-tickets-check',
						{ arrayOfIds: dataId },
						function (res) {
							if (res.length > 2) {
								let jsonData = JSON.parse(res);
								let count = jsonData[0].AvailableCount;
								if (count < 1) {
									if (item.classList.contains('evModal__item--disabled')) {
										return;
									}
									item.classList.add('evModal__item--disabled');
								}
							} else {
								item.classList.add('evModal__item--disabled');
							}
						}
					);
				}
			});
		}

		function closeEventsModal(event) {
			if (
				event.target.classList.contains('evModal') ||
				event.target.classList.contains('evModal__closeDates')
			) {
				evModal.classList.remove('evModal--open');
				closeAddToCals();
			}
		}
		// close modal for additional events
		if (evModal) {
			evModal.addEventListener('click', closeEventsModal);
		}
		// evModal.addEventListener('click', closeEventsModal);
		// open modal for additional events
		otherDates.addEventListener('click', function () {
			closeAddToCals();
			openModal();
			checkTickets();
		});
	}
}
